import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuSeparator,
    ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { useParams, useNavigate } from "react-router-dom";
import { UpdateChannel } from "../Dialogs/UpdateChannel";
import { Channel } from "types";
import { useState } from "react";
import Icon from "@/icons";
import toast from "react-hot-toast";

export const ManageChannel = ({ children, channel }: { children: React.ReactNode, channel: Channel }) => {
    const { teamId, channelId } = useParams();
    const navigate = useNavigate();

    const handleDeleteChannel = async () => {
        const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/channels/${channel.id}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (data.message) return toast.error(data.message);
        if (channel.id === channelId) navigate(`/teams/${teamId}`);
    };

    const handleCloneChannel = async () => {
        const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/channels/${channel.id}/clone`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (data.message) return toast.error(data.message);
        navigate(`/teams/${teamId}/channels/${data.channel.id}`);

        toast.success("Channel cloned successfully");
    };

    return (
        <ContextMenu>
            <ContextMenuTrigger>
                {children}
            </ContextMenuTrigger>
            <ContextMenuContent className="bg-brand-default min-w-60 p-0 px-0 py-0 space-y-0 font-bold rounded-lg text-white border-0 shadow-xl shadow-brand ">
                <UpdateChannel channel={channel} full={true}>
                    <ContextMenuItem
                        onSelect={(e) => e.preventDefault()}
                        className="hover:bg-brand-profile text-white focus:text-white focus:bg-brand-profile"
                    >
                        <div className="flex items-center gap-2 text-gray-300">
                            <Icon name="pencil" size={"18"} />
                            <p className="text-white">Edit Channel</p>
                        </div>
                    </ContextMenuItem>
                </UpdateChannel>

                <ContextMenuItem className="hover:bg-brand-profile text-white focus:text-white focus:bg-brand-profile" onClick={handleCloneChannel}>
                    <div className="flex items-center gap-2 text-gray-300">
                        <Icon name="clone" size={"18"} />
                        <p className="text-white">Clone Channel</p>
                    </div>
                </ContextMenuItem>

                <ContextMenuSeparator />
                <ContextMenuItem className="hover:bg-brand-profile text-red-400 focus:text-red-400 focus:bg-brand-profile" onClick={handleDeleteChannel}>
                    <div className="flex items-center gap-2">
                        <Icon name="delete" size={"18"} />
                        <p>Delete Channel</p>
                    </div>
                </ContextMenuItem>
            </ContextMenuContent>
        </ContextMenu>
    );
};
